import React, {useState} from 'react';

const Client = (props) => {
    if(Object.keys(props.clientPosition).length === 0){
        return null;
    }
    const viewHeight = props.isPortrait ? window.innerWidth * 1.25 
                        : props.isLandscape ? window.innerWidth * 0.75
                        : props.viewHeight;
    const textStyle = {
        color: props.clientPosition.textColor,
        fontFamily: props.clientPosition.fontFamily,
        fontWeight: props.clientPosition.fontWeight,
        fontStyle: props.clientPosition.fontStyle,
        fontSize: `${(props.clientPosition.fontSize || 2) * viewHeight / 100}px`,
    }
    const contactNameStyle = {
        top: props.clientPosition.position_name_y+"%",
        left: props.clientPosition.position_name_x+"%",
        display: (props.clientPosition.show_name !== false) ? "block" : "none",
        ...textStyle
    }
    const contactPhoneStyle = {
        top: props.clientPosition.position_phone_y+"%",
        left: props.clientPosition.position_phone_x+"%",
        display: props.clientPosition.show_phone !== false ? "block" : "none",
        ...textStyle,
    }
    const contactEmailStyle = {
        top: props.clientPosition.position_contact_y+"%",
        left: props.clientPosition.position_contact_x+"%",
        display: props.clientPosition.show_contact !== false ? "block" : "none",
        ...textStyle,
    }
    const clientLogoStyle = {
        width: props.clientPosition.width+"%",
        top: props.clientPosition.position_logo_y+"%",
        left: props.clientPosition.position_logo_x+"%",
        display: props.clientPosition.show_logo !== false ? "block" : "none",
        ...textStyle,
    }

    const emailLink = "mailto:" + props.clientData.contact_email
    return(
        <div className="client_wrap">
            {/*<p className="client_name" style={clientNameStyle}>{props.clientData.client_name}</p>*/}
            <p className="contact_name" style={contactNameStyle}>{props.clientData.contact_name}</p>
            <p className="contact_phone" style={contactPhoneStyle}>{props.clientData.contact_phone}</p>
            <p className="contact_email" style={contactEmailStyle}>
                <a href={emailLink} style={{
                    fontSize: contactEmailStyle.fontSize,
                    color: contactEmailStyle.color,
                }}>
                    {props.clientPosition.emailButton ? (<i className="fa fa-envelope"></i>) : props.clientData.contact_email}
                </a>
            </p>

            <a href={props.clientData.url_click} target="_blank">
                <img className="client-logo" src={props.clientPosition.logo.replace('/media', 'https://storage.googleapis.com/ifloorplan-8278e.appspot.com')} style={clientLogoStyle}/>
            </a>
        </div>
    )
}
export default Client;